<template>
    <li
        class="episodes-list-item"
    >
        <div class="episodes-featured-column">
            <featured-button
                :track-no="episode.trackNo"
                :player-featured="episode.featured"
                :show="show"
            />
        </div>
        <div class="episodes-title-column">
            <a
                v-if="!episodeModal.isAudioFileUploading()"
                href="#"
                class="episodes-title"
                :title="episode.title"
                @click="editEpisode"
            >
                {{ episode.title }}
            </a>
            <span
                v-else
                class="episodes-title disabled"
                :title="episode.title"
            >
                {{ episode.title }}
            </span>

            <transition name="fade" mode="out-in">
                <div
                    v-if="'deleting' === episode.status"
                    class="episode-status"
                >
                    Deleting...
                </div>
                <publication-timestamp
                    v-else
                    context="list"
                    class="episode-status"
                    :emphasized="false"
                    :published-at="episode.publishedAt"
                    :created-at="episode.createdAt"
                />
            </transition>
        </div>
        <div class="episodes-season-episode-column">
            {{ seasonEpisode }}
        </div>
        <div class="episodes-duration-column">
            <span
                class="episodes-duration"
                :class="{ 'empty-value': ! episode.duration }"
            >
                {{ episode.durationFormatted || '&ndash;' }}
            </span>
        </div>
        <div class="episodes-total-listens-column">
            <span
                class="episodes-total-listens"
                :class="{ 'empty-value': ! episode.totalListens }"
            >
                {{ episode.totalListens || '&ndash;' }}
            </span>
        </div>
        <div class="episodes-actions-column">
            <button
                v-if="'deleting' !== episode.status"
                class="episodes-edit-button"
                :disabled="episodeModal.isAudioFileUploading()"
                @click="editEpisode"
            >
                <i class="far fa-pen" />
                Edit
            </button>
        </div>
    </li>
</template>
<script>
import { mapMutations, mapState } from 'vuex';
import FeaturedButton from '@/components/FeaturedButton';
import PublicationTimestamp from '@/components/Shows/Episodes/PublicationTimestamp';
import episodeModal from '@/utils/episodeModal';
import { UPLOAD_STATUS_WAITING, UPLOAD_STATUS_UPLOADED } from '@/utils/config/episodeOptions';

export default {
    components: {
        FeaturedButton,
        PublicationTimestamp,
    },

    props: {
        episode: {
            required: true,
            type: Object,
        },

        show: {
            type: [Object, Boolean],
            default: () => ({}),
        },
    },

    data: () => ({
        episodeModal,
    }),

    computed: {
        ...mapState(['UIState']),

        /**
         * Computes value for "Season/Episode" column.
         *
         * @returns {string} Value for "Season/Epsode" column.
         */
        seasonEpisode() {
            if ('serial' === this.show.podcastType) {
                return `${this.episode.seasonNo} / ${this.episode.episodeNo}`;
            }

            return this.episode.episodeNo;
        },
    },

    methods: {
        ...mapMutations(['changeUIState']),

        /**
         * Shows Episode modal with current Episode data.
         */
        editEpisode() {
            episodeModal.setInitialData(this.show, { context: 'edit' });
            episodeModal.setEpisode(this.episode);
            episodeModal.setAudioFileUploadStatus(
                episodeModal.hasAudioFile() ? UPLOAD_STATUS_UPLOADED : UPLOAD_STATUS_WAITING
            );
            episodeModal.open();
        },
    },
};
</script>
